import { Fuel, Loader2, MapPin } from "lucide-react";

const km = (n) => n.toLocaleString("es-ES", { maximumFractionDigits: 1 });

export const DeliverySummary = ({ quote, loading, error, config }) => {
  if (loading) {
    return (
      <li className="flex items-center gap-2 text-slate-500" data-testid="delivery-loading">
        <Loader2 className="h-3.5 w-3.5 animate-spin text-cyan-500" /> Calculando distancia desde el local...
      </li>
    );
  }
  if (error) {
    return (
      <li data-testid="delivery-error" className="text-xs text-red-700 bg-red-50 border border-red-100 rounded-lg p-2.5 leading-relaxed">
        {error}
      </li>
    );
  }
  if (!quote) {
    return (
      <li className="flex justify-between items-center text-slate-500" data-testid="delivery-pending">
        <span className="flex items-center gap-2"><Fuel className="h-4 w-4 text-slate-400" /> Desplazamiento</span>
        <span className="text-xs">{config ? `gratis ≤ ${km(config.free_km)} km` : "según dirección"}</span>
      </li>
    );
  }
  const free = quote.fee === 0;
  return (
    <li data-testid="delivery-line" className="space-y-1.5">
      <div className="flex justify-between items-center">
        <span className="text-slate-600 flex items-center gap-2">
          <Fuel className="h-4 w-4 text-cyan-500" /> Desplazamiento
          <span data-testid="delivery-km" className="text-xs bg-cyan-50 text-cyan-700 px-2 py-0.5 rounded-full font-medium">
            {km(quote.distance_km)} km
          </span>
        </span>
        <span className="font-medium" data-testid="delivery-fee">
          {free ? <span className="text-emerald-600">Gratis</span> : `${quote.fee.toFixed(2)} €`}
        </span>
      </div>
      <p className="text-xs text-slate-400 leading-relaxed" data-testid="delivery-explanation">
        {free
          ? `Estás a menos de ${km(quote.free_km)} km del local: sin coste de gasolina.`
          : `Gratis los primeros ${km(quote.free_km)} km · ${km(quote.distance_km - quote.free_km)} km extra × ${quote.rate_per_km.toFixed(2)} €/km.`}
      </p>
      <p className="text-[11px] text-slate-400 flex items-start gap-1" data-testid="delivery-resolved">
        <MapPin className="h-3 w-3 mt-0.5 shrink-0" /> <span className="line-clamp-2">{quote.resolved_address}</span>
      </p>
    </li>
  );
};
